import { z } from "zod";
import { TGeoPoint } from "./base";
import { TVisibilitySource } from "./unit/unit.visibility";
import { TFirebaseTimestamp } from "./deprecated";

export type IRawBaseInfoField = z.infer<typeof TRawBaseInfoField>;
export const TRawBaseInfoField = z.object({
  suffix: z.string().optional(),
  visibility: z.array(TVisibilitySource).optional(),
});

export type IRawBooleanInfoFieldValue = z.infer<
  typeof TRawBooleanInfoFieldValue
>;
export const TRawBooleanInfoFieldValue = z
  .object({
    value: z.boolean().nullish(),
  })
  .extend(TRawBaseInfoField.shape)
  .nullable();

export type IRawGeoPointInfoFieldValue = z.infer<
  typeof TRawGeoPointInfoFieldValue
>;
export const TRawGeoPointInfoFieldValue = z
  .object({
    value: TGeoPoint.nullish(),
  })
  .extend(TRawBaseInfoField.shape)
  .nullable();

export type IRawNumberInfoFieldValue = z.infer<typeof TRawNumberInfoFieldValue>;
export const TRawNumberInfoFieldValue = z
  .object({
    value: z.number().nullish(),
  })
  .extend(TRawBaseInfoField.shape)
  .nullable();

export type IRawNumberArrayInfoFieldValue = z.infer<
  typeof TRawNumberArrayInfoFieldValue
>;
export const TRawNumberArrayInfoFieldValue = z
  .object({
    value: z.array(z.number()).nullish(),
  })
  .extend(TRawBaseInfoField.shape)
  .nullable();

export type IRawStringInfoFieldValue = z.infer<typeof TRawStringInfoFieldValue>;
export const TRawStringInfoFieldValue = z
  .object({
    value: z.string().nullish(),
  })
  .extend(TRawBaseInfoField.shape)
  .nullable();

export type IRawStringArrayInfoFieldValue = z.infer<
  typeof TRawStringArrayInfoFieldValue
>;
export const TRawStringArrayInfoFieldValue = z
  .object({
    value: z.array(z.string()).nullish(),
  })
  .extend(TRawBaseInfoField.shape)
  .nullable();

export type IRawTimestampInfoFieldValue = z.infer<
  typeof TRawTimestampInfoFieldValue
>;
export const TRawTimestampInfoFieldValue = z
  .object({
    value: TFirebaseTimestamp.nullish(),
  })
  .extend(TRawBaseInfoField.shape)
  .nullable();

export type IRawArrayInfoFieldValue = z.infer<typeof TRawArrayInfoFieldValue>;
export const TRawArrayInfoFieldValue = z
  .object({
    value: z.union([z.array(z.number()), z.array(z.string())]).nullish(),
  })
  .extend(TRawBaseInfoField.shape)
  .nullable();
